import React from 'react'
import ReactDOM from 'react-dom'

import './style.scss'

class Modal extends React.Component {
  componentWillMount() {
    this.modalRoot = document.createElement('div')
    this.modalRoot.classList.add('modal')
    this.modalRoot.classList.add(this.props.modalView)
    document.body.appendChild(this.modalRoot)
    document.body.classList.add('lock', 'modal-open')
    document.body.classList.remove('modal-close')
  }

  componentWillUnmount() {
    if (!this.props.isModalOpen) {
      document.body.removeChild(this.modalRoot)
      document.body.classList.add('modal-close')
      document.body.classList.remove('lock', 'modal-open')
    }
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.modalRoot
    );
  }
}

export default Modal
